import { render, staticRenderFns } from "./SetupView.vue?vue&type=template&id=449ad73c&scoped=true&"
import script from "./SetupView.vue?vue&type=script&setup=true&lang=js&"
export * from "./SetupView.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SetupView.vue?vue&type=style&index=0&id=449ad73c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449ad73c",
  null
  
)

export default component.exports